import React from 'react';
import { EmptyState } from "@dev/ee-components";
import { useTranslation } from "react-i18next";
import { EmptyStateWrapper, LandingPagePublishUnavailableMessage } from './styles';

export const LandingPagePublishUnavailable = (): JSX.Element => {
    const { t } = useTranslation();
    return (
        <EmptyStateWrapper>
            <EmptyState
                text={
                    <LandingPagePublishUnavailableMessage>
                        {t('nodatatodisplay')}<br />{t('nolandingpagepublishlinks')}
                    </LandingPagePublishUnavailableMessage>
                } 
            />
        </EmptyStateWrapper>

    )
};
